import { createStructuredSelector } from 'reselect';
import {
  arbitratorCreateModalOpenSelector,
  arbitratorSelector,
} from '../../selectors/arbitrator';

export default createStructuredSelector({
  modalOpen: arbitratorCreateModalOpenSelector,
  createdArbitrator: arbitratorSelector,
});
